"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranscodingState = void 0;
var _react = _interopRequireDefault(require("react"));
var _ = require("../..");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TranscodingState = require("./TranscodingState.styled");
var PROCESSING_MESSAGE = 'This file is being transcoded and will be available shortly.';
var TranscodingState = exports.TranscodingState = function TranscodingState(_ref) {
  var status = _ref.status,
    onSourceDeleted = _ref.onSourceDeleted;
  if (!status) return null;
  return _react["default"].createElement(_TranscodingState.Wrapper, null, _react["default"].createElement(_.TranscodeProcessing, {
    status: status.toUpperCase(),
    theme: "light",
    tooltipText: PROCESSING_MESSAGE,
    canRetry: false,
    onSourceDeleted: onSourceDeleted
  }));
};
TranscodingState.propTypes = {
  status: _propTypes["default"].string,
  onSourceDeleted: _propTypes["default"].func
};